import { QuoteEmail } from "./email.model";
import { QuoteLocation } from "./quote-location.model";
import { Client } from "../../client/client.model";
import { BaseUser } from "../../user/base-user.model";
import { BaseStandardQuote } from "./quote-base-standard.model";
import { LocalCostLabel } from "./local-cost-label.model";
import { AirWeightBracketName } from "app/shared/air-weight-bracket/air-weight-bracket-name.type.const";
import { Insurance } from "./insurance.model";

export class AirTariffQuote extends BaseStandardQuote {
  constructor(
    protected id: number,
    protected displayId: string,
    protected groupId: number,
    protected ref: string,
    protected sender: BaseUser,
    protected createdBy: BaseUser,
    protected status: string,
    protected quoteType: string,
    protected direction: string,
    protected incotermType: string,
    protected clients: Client[],
    protected originLocations: QuoteLocation[],
    protected destinationLocations: QuoteLocation[],
    protected localCostLabels: LocalCostLabel[],
    protected weightBrackets: AirWeightBracketName[],
    protected createdAt: Date,
    protected updatedAt: Date,
    protected updatedBy: BaseUser,
    protected openedAt: Date,
    protected validFrom: Date,
    protected validTo: Date,
    protected comment: string,
    protected showCarrier = false,
    protected email: QuoteEmail,
    protected internalComment: string,
    protected customTerms: string,
    protected fileName: string,
    protected fileNameInternal: string,
    protected inquiry: string,
    protected source: string,
    protected insurance: Insurance | null,
    protected reasonOfDecline: string,
    protected input: string | null,
    protected offerLanguage: string | null,
    protected hasOrigin: boolean,
    protected hasDestination: boolean,
  ) {
    super(
      id,
      displayId,
      groupId,
      ref,
      sender,
      createdBy,
      status,
      quoteType,
      clients,
      createdAt,
      updatedAt,
      updatedBy,
      openedAt,
      validFrom,
      validTo,
      email,
      internalComment,
      customTerms,
      fileName,
      fileNameInternal,
      null,
      inquiry,
      source,
      insurance,
      reasonOfDecline,
      input,
      offerLanguage,
      hasOrigin,
      hasDestination,
      originLocations,
      destinationLocations,
      localCostLabels,
    );
  }

  public getDirection(): string {
    return this.direction;
  }

  public setDirection(direction: string): void {
    this.direction = direction;
  }

  public getIncotermType(): string {
    return this.incotermType;
  }

  public setIncotermType(type: string): void {
    this.incotermType = type;
  }

  public getOriginLocations(): QuoteLocation[] {
    return this.originLocations;
  }

  public setOriginLocations(locations: QuoteLocation[]): void {
    this.originLocations = locations;
  }

  public getDestinationLocations(): QuoteLocation[] {
    return this.destinationLocations;
  }

  public setDestinationLocations(locations: QuoteLocation[]): void {
    this.destinationLocations = locations;
  }

  public getComment(): string {
    return this.comment;
  }

  public setComment(comment: string) {
    this.comment = comment;
  }

  public getWeightBrackets(): AirWeightBracketName[] {
    return this.weightBrackets;
  }

  public setWeightBrackets(weightBrackets: AirWeightBracketName[]) {
    this.weightBrackets = weightBrackets;
  }

  public getShowCarrier(): boolean {
    return this.showCarrier;
  }

  public setShowCarrier(param: boolean) {
    this.showCarrier = param;
  }
}
